export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Dr. Nirajan. All rights reserved.</p>

      <style>{`
        .footer {
          background: #5D3FD3;
          color: white;
          text-align: center;
          padding: 20px 0;
        }
        .footer p { margin: 0; }
      `}</style>
    </footer>
  );
}
